import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityFeed = ({ activities }) => {
  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden shadow-sm">
      <div className="px-6 py-4 border-b border-border">
        <h2 className="text-xl font-semibold text-foreground">Recent Activity</h2>
        <p className="text-sm text-muted-foreground mt-1 font-caption">
          Latest platform events and updates
        </p>
      </div>
      <div className="divide-y divide-border">
        {activities?.map((activity) => (
          <div
            key={activity?.id}
            className="px-6 py-4 hover:bg-muted/50 transition-colors duration-200"
          >
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-full bg-muted flex items-center justify-center flex-shrink-0">
                <Icon name={activity?.icon} size={20} className={activity?.iconColor} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-foreground font-medium">{activity?.message}</p>
                <p className="text-xs text-muted-foreground mt-1 font-caption">
                  {activity?.timestamp}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="px-6 py-4 border-t border-border bg-muted/30">
        <button className="text-sm text-primary hover:underline font-medium">
          View all activity →
        </button>
      </div>
    </div>
  );
};

export default ActivityFeed;